export const memberHomeCn = {
  shishizhibiao: "实时指标",
  jiancherenzhenfuwu: "检测认证服务",
  shenghe:'审核中',
  zhixunbaojia:'咨询报价',
  peixunfuwu:'培训服务',
  zhuanjiazhixun:'专家咨询',
  weiwangchengdingdang:'未完成订单',
  more:'查看更多',
  dingdangxiangqing:'订单详情',
  dingdanghao:'订单号',
  riqi:'日期',
  zhuantai:'状态',
  caozuo:'操作',
  zuijinlioulanfuwu:'最近浏览服务',
  zuijinshoucangfuwu:'最近收藏服务'
}



// WEBPACK FOOTER //
// ./src/lang/member/memberHome/memberHomeCn.js